module.exports = __webpack_public_path__ + "static/media/grin.8a8284b3.svg";